import { HashTabSection } from "../../components/Helpers"
import { Files } from "./files_tab/Files"

export function FilesContainer() {
  return (
    <HashTabSection
      defaultTab="files"
      tabItems={[{ id: "files", label: "Files" }]}
      tabContent={{ files: <Files /> }}
    />
  )
}
